import { render, staticRenderFns } from "./thirdStep - 副本.vue?vue&type=template&id=1253ce8b&scoped=true&"
import script from "./thirdStep - 副本.vue?vue&type=script&lang=js&"
export * from "./thirdStep - 副本.vue?vue&type=script&lang=js&"
import style0 from "./thirdStep - 副本.vue?vue&type=style&index=0&id=1253ce8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1253ce8b",
  null
  
)

export default component.exports